import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

const reassuranceMessageCarousel = {
    elements: {
        $document: $(document),
    },

    selectors: {
        carousel: '.js-reassurance-message-carousel',
    },

    settings: {
        carouselParameters:
        {
            modules: [Pagination],
            centeredSlides: true,
            pagination: {
                el: ".js-reassurance-message-pagination",
                clickable: true,
            },
        }
    },

    init() {
        this.initCarousel();
    },

    initCarousel() {
        new Swiper(this.selectors.carousel, this.settings.carouselParameters);
    }
};

reassuranceMessageCarousel.init();

